import { useEffect, useRef, useState } from "react";
import TEXT from "../../../utils/globalText";
import { globalTextFormat } from "../../../utils/globalTextFormat";
import AssignLabels from "../../_utils/AccountCreationComponents/AssignLabels";
import CommonAssignLabelPopup from "../../_utils/CommonPopups/CommonAssignLabelPopup";
import DynamicAdditionalFields from "../../_utils/TransactionCommonComponents/DynamicAdditionalFields";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import CommonLayout from "../../_utils/CommonLayout";

const InternalTxnAdditionalDetails = (props) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dateRef = useRef(null);
  const dropdownRefs = useRef(null);

  const [dropdowns, setDropdowns] = useState({});
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerlabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerlabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  const handleClose = (finalLabels) => {
    setShowLabelModal(false);
    const labelsToUse = Array.isArray(finalLabels)
      ? finalLabels
      : selectedLabelsCreate;
    const currentOwnerLabels = props?.txnPayLoad?.ownerlabels || [];
    const newOwnerLabels = labelsToUse.filter((label) =>
      currentOwnerLabels.includes(label),
    );
    const newOtherLabels = labelsToUse.filter(
      (label) => !currentOwnerLabels.includes(label),
    );
    setSelectedLabelsCreate(labelsToUse);
    props?.setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerlabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };

  const handleInputChange = (e, data_type) => {
    if (data_type === "numeric" && e.target.value?.length > 15) return;

    if (e.preventDefault) e.preventDefault();

    const {
      name,
      value,
      data_type: data_typeChan,
    } = e.target || {
      name: e.name,
      value: e.value,
    };

    const field =
      props?.txnPayLoad?.selectedCategory?.configuration?.data?.find(
        (field) => field.name === name,
      );

    let updatedData = { ...props.additionalData };

    const isNonTrimmedType =
      data_typeChan === "date" ||
      data_typeChan === "year" ||
      data_typeChan === "toggle" ||
      data_typeChan === "time" ||
      data_typeChan === "quantity" ||
      data_typeChan === "from_year_to_year" ||
      data_typeChan === "month_year" ||
      data_typeChan === "date_range" ||
      data_typeChan === "multi_select_list" ||
      data_typeChan === "upload";

    const trimmedValue =
      isNonTrimmedType || typeof value !== "string"
        ? value
        : value.replace(/^\s+/, "");

    if (data_typeChan === "month_year" && value?.month && value?.year) {
      const monthNumber = new Date(`1 ${value.month}`).getMonth() + 1;

      const formattedMonth = monthNumber.toString().padStart(2, "0");

      const formattedValue = `${formattedMonth}/${value.year}`;

      updatedData[name] = formattedValue;
      props.setAdditionalData(updatedData);
      return;
    }

    if (field?.data_type === "numeric") {
      if (trimmedValue === "") {
        updatedData[name] = "";
        props.setAdditionalData(updatedData);
        return;
      }

      if (!/^\d+$/.test(trimmedValue)) return;

      updatedData[name] = Number(trimmedValue);
      props.setAdditionalData(updatedData);
      return;
    }

    updatedData[name] = trimmedValue;
    props.setAdditionalData(updatedData);

    if (field?.data_type === "list") {
      setDropdowns((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          selectedOption: trimmedValue,
        },
      }));
    }
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (value < 0 || value.length > 15) {
      return;
    }

    props?.setQuantity((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: Number(value) || 0,
        data_typeChan: data_type,
      },
    });
  };

  useEffect(() => {
    const combinedLabels = [
      ...(props?.txnPayLoad?.ownerlabels || []),
      ...(props?.txnPayLoad?.labels || []).filter(
        (label) => !(props?.txnPayLoad?.ownerlabels || []).includes(label),
      ),
    ];
    setSelectedLabelsCreate(combinedLabels);
  }, [props?.txnPayLoad?.labels, props?.txnPayLoad?.ownerlabels]);

  useEffect(() => {
    const availableLabels = sessionStorage.getItem(
      "AvailableLabelsInternalTxn",
    );
    try {
      const parsedJson = availableLabels ? JSON.parse(availableLabels) : [];
      setLabels(Array.isArray(parsedJson) ? parsedJson : []);
    } catch {
      setLabels([]);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        props?.setShowDatePickerCal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!props?.additionalData) return;
    if (!props?.txnPayLoad?.selectedCategory?.configuration?.data) return;

    const storeData = props.txnPayLoad.selectedCategory.configuration.data.map(
      (val) => {
        const dataValue = props.additionalData[val.name];

        if (
          dataValue === undefined ||
          dataValue === "" ||
          (Array.isArray(dataValue) &&
            dataValue.length === GlobalConfiguration.lengthCheckZero)
        ) {
          if (props.initialRefactorAdditionalDetail?.[val.name]?.isCopyDirect) {
            props.setInitialRefactorAdditionalDetail((prev) => ({
              ...prev,
              [val.name]: {
                ...prev[val.name],
                isCopyDirect: false,
                isCopyClick: false,
                isPaste: {},
              },
            }));
          }
        }

        if (val.data_type === "multi_select_list") {
          return {
            ...val,
            value: Array.isArray(dataValue) ? dataValue : [],
          };
        }

        if (dataValue === undefined || dataValue === "") {
          switch (val.data_type) {
            case "multi_select_list":
              return { ...val, value: [] };

            case "toggle":
              return { ...val, value: false };

            case "quantity":
              return { ...val, value: 0 };

            case "hyperlink":
            case "upload":
            case "time":
              return { ...val, value: "" };

            case "date_range": {
              if (val.mandatory !== "Y") {
                const { value, ...rest } = val;
                return rest;
              }

              return {
                ...val,
                value: {
                  start_date: dataValue?.start_date || "",
                  end_date: dataValue?.end_date || "",
                },
              };
            }

            case "from_year_to_year": {
              if (val.mandatory !== "Y") {
                const { value, ...rest } = val;
                return rest;
              }

              return {
                ...val,
                value: {
                  from: dataValue?.from ?? "",
                  to: dataValue?.to ?? "",
                },
              };
            }

            default:
              return val.mandatory !== "Y" ? { ...val, value: "" } : val;
          }
        }

        switch (val.data_type) {
          case "numeric": {
            const num = Number(dataValue);
            return {
              ...val,
              value: isNaN(num) ? "" : num,
            };
          }

          case "toggle":
            return {
              ...val,
              value: dataValue === true,
            };

          case "multi_select_list":
            return {
              ...val,
              value: Array.isArray(dataValue) ? dataValue : [],
            };

          case "date_range":
            return {
              ...val,
              value: {
                start_date: dataValue?.start_date || "",
                end_date: dataValue?.end_date || "",
              },
            };

          case "month_year": {
            if (typeof dataValue === "string") {
              return { ...val, value: dataValue };
            }

            if (dataValue?.month && dataValue?.year) {
              const monthIndex = months.indexOf(dataValue.month) + 1;

              const formattedMonth = String(monthIndex).padStart(2, "0");

              return {
                ...val,
                value: `${formattedMonth}/${dataValue.year}`,
              };
            }

            return { ...val, value: "" };
          }

          case "from_year_to_year": {
            const from =
              dataValue?.from !== undefined && dataValue?.from !== null
                ? Number(dataValue.from)
                : "";

            const to =
              dataValue?.to !== undefined && dataValue?.to !== null
                ? Number(dataValue.to)
                : "";

            return {
              ...val,
              value: {
                from: isNaN(from) ? "" : from,
                to: isNaN(to) ? "" : to,
              },
            };
          }

          case "time":
            return {
              ...val,
              value: dataValue || "",
            };

          default:
            return {
              ...val,
              value: dataValue,
            };
        }
      },
    );

    props.setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
  }, [props.additionalData, props.txnPayLoad.selectedCategory]);

  useEffect(() => {
    if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "time"
    ) {
      const timeStr = props?.copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        props?.copyData?.title,
        props?.copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      props?.setTimeData((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,
          value: props?.copyData?.value,
          data_type: props?.copyData?.data_type,
        },
      });

      let data = new Date(props?.copyData?.value);

      props?.setStartDate((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,
          [key]: data,
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        props?.copyData?.value || 0,
        props?.copyData?.title,
        props?.copyData?.data_type,
        `${props?.copyData?.title}_${props?.copyData?.data_type}`,
      );

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,
          value: props?.copyData?.value,
          data_typeChan: props?.copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = props?.copyData?.value.split("/");

      const monthIndex = parseInt(monthStr, 10) - 1;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [monthName, parseInt(yearStr, 10)];

      props?.setSelectedValueMonth((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setSelectedValue((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        const prevVal = prev[key] || {};

        return {
          ...prev,
          [key]: {
            from:
              props?.copyData?.value?.from !== undefined
                ? Number(props.copyData.value.from)
                : (prevVal.from ?? ""),
            to:
              props?.copyData?.value?.to !== undefined
                ? Number(props.copyData.value.to)
                : (prevVal.to ?? ""),
          },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date_range"
    ) {
      const parse = (d) => {
        if (!d) return null;

        // Handle "D MMM, YYYY" format e.g. "5 Jan, 2024"
        if (typeof d === "string" && d.includes(" ")) {
          const parsed = new Date(d);
          return isNaN(parsed.getTime()) ? null : parsed;
        }

        // Handle "DD/MM/YYYY" format
        const parts = d.split("/").map(Number);
        if (parts.length === 3) {
          const [day, month, year] = parts;
          return new Date(year, month - 1, day);
        }

        return null;
      };

      const startVal = parse(props?.copyData?.value?.start_date);
      const endVal = parse(props?.copyData?.value?.end_date);
      const fieldKey = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

      if (startVal) {
        props?.setStartDate((prev) => ({
          ...prev,
          [fieldKey]: startVal,
        }));
      }

      if (endVal) {
        props?.setEndDate((prev) => ({
          ...prev,
          [fieldKey]: endVal,
        }));
      }

      // ✅ Update additionalData with the raw value object
      props?.setAdditionalData((prev) => ({
        ...prev,
        [props?.copyData?.title]: props?.copyData?.value,
      }));

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    }
  }, [props?.copyData]);

  useEffect(() => {
    if (!props?.initialRefactorAdditionalDetail) return;

    Object.entries(props.initialRefactorAdditionalDetail).forEach(
      ([key, fieldMeta]) => {
        if (fieldMeta?.isCopyClick && fieldMeta?.isPaste) {
          const pasteDataType = fieldMeta?.isPaste?.data_type;

          if (pasteDataType === "hyperlink") {
            const value = fieldMeta.isPaste.value ?? "";
            const fieldKey = `${key}_hyperlink`;

            props?.setHyperLink((prev) => ({
              ...prev,
              [fieldKey]: value,
            }));

            handleInputChange({
              target: {
                name: key,
                value: value,
                data_type: "hyperlink",
              },
            });

            props?.setInitialRefactorAdditionalDetail((prev) => ({
              ...prev,
              [key]: {
                ...prev[key],
                isCopyClick: false,
                isPaste: {},
              },
            }));
          }
        }
      },
    );
  }, [props?.initialRefactorAdditionalDetail]);

  return (
    <>
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={Array.isArray(labels) ? labels : []}
            setLabels={setLabels}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            isLabelPopupOpen={showLabelModal}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            type="create"
          />
        </div>
      )}

      <div
        className={`${showLabelModal ? "fixed overflow-y-hidden" : ""} relative z-z-index-content w-width-full max-w-screen-lg px-padding-md lg:px-padding-base lg:pb-padding-base pb-padding-md snap-start flex flex-col gap-gap-md Qsmd:gap-gap-xl lg:flex-row justify-center  ${props?.reminder_remark !== null && props?.flow === "ReminderFlow" ? "pt-padding-md" : props?.refactor ? "pt-padding-xl Qsmd:pt-padding-md" : "lg:pt-padding-md pt-padding-md"}`}
      >
        <CommonLayout>
          <div className="bg-primary-card h-auto flex flex-col p-padding-md rounded-border-radius-md items-start lg:mb-margin-md">
            <div className="text-text-primary font-semibold text-font-md flex flex-row justify-between">
              <p className="text-center pb-padding-md">
                {globalTextFormat(TEXT.ADDITIONAL_DETAILS, [0, 1])}
              </p>
            </div>
            <div className="w-width-full flex flex-col gap-gap-md">
              <div className="w-width-full flex flex-col gap-gap-md">
                <DynamicAdditionalFields
                  mergeCategory={props?.txnPayLoad?.mergeCategory}
                  additionalData={props?.additionalData}
                  setAdditionalData={props?.setAdditionalData}
                  hyperLink={props?.hyperLink}
                  setHyperLink={props?.setHyperLink}
                  timeData={props?.timeData}
                  setTimeData={props?.setTimeData}
                  quantities={props?.quantity}
                  setQuantities={props?.setQuantity}
                  uploadedFiles={props?.uploadedFiles}
                  setUploadedFiles={props?.setUploadedFiles}
                  startDate={props?.startDate}
                  endDate={props?.endDate}
                  setStartDate={props?.setStartDate}
                  setEndDate={props?.setEndDate}
                  selectedValue={props?.selectedValue}
                  setSelectedValue={props?.setSelectedValue}
                  selectedValueMonth={props?.selectedValueMonth}
                  setSelectedValueMonth={props?.setSelectedValueMonth}
                  initialRefactorAdditionalDetail={
                    props?.initialRefactorAdditionalDetail
                  }
                  setInitialRefactorAdditionalDetail={
                    props?.setInitialRefactorAdditionalDetail
                  }
                  previewImages={props.previewImages}
                  setPreviewImages={props.setPreviewImages}
                  onInputChanged={(name, value, dataType) => {
                    props?.setAdditionalData((prev) => ({
                      ...prev,
                      [name]: value,
                    }));
                  }}
                />
              </div>
            </div>
          </div>

          <AssignLabels
            setLabelpopup={setShowLabelModal}
            labels={selectedLabelsCreate}
            subText1={TEXT?.LABELS_USAGE_NOTE}
            subText2="The labels below are auto assigned as per selected internal and owner accounts."
            isOptional={true}
          />
        </CommonLayout>
        {/* <div className="py-padding-xl my-margin-xl block lg:hidden"></div> */}
      </div>
    </>
  );
};

export default InternalTxnAdditionalDetails;
